import Cookies from "js-cookie";

if (window.sessionStorage && Cookies.get("ClearVue")) {
  window.sessionStorage.removeItem("main");
  Cookies.remove("ClearVue");
}
